import axios from 'axios';
import { API_CONFIG } from '../config/endpoints.js';
import { tokenService } from './tokenService.js';

// Instância do axios
const api = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'Accept': 'application/json',
  },
});

// Interceptor para adicionar o token de autorização
api.interceptors.request.use(
  (config) => {
    // Obter o token apropriado baseado na rota
    const token = tokenService.getTokenForRoute(config.url);
    
    if (token) {
      config.headers.Authorization = token;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Só redireciona para login se for 401 em uma requisição autenticada
    // Ignora 401 nas rotas de login para evitar loop de refresh
    const url = error.config?.url || '';
    const isLoginRoute =
      url.includes('app/login') ||
      url.includes('users/login') ||
      url.includes('users/verify-email') ||
      url.includes('users/reset-password') ||
      url.includes('users/update-password');
    
    // Debug: log para verificar o que está acontecendo
    if (error.response?.status === 401) {
      console.log('401 detectado:', {
        url,
        isLoginRoute,
        willRedirect: !isLoginRoute
      });
    }
    
    if (error.response?.status === 401 && !isLoginRoute) {
      tokenService.clearAll();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export { api };
export { API_CONFIG } from '../config/endpoints.js';
